import { useQuery } from 'react-query'
import axios from 'axios'

// Use deployed API when running locally
const getApiBase = () => {
  if (import.meta.env.DEV) {
    return 'https://fa99a3c6.socialfi-lunatics.pages.dev/api/twitter'
  }
  return '/api/twitter'
}

const API_BASE = getApiBase()

// Fetch real leaderboard data from Twitter analytics
const fetchLeaderboard = async (timeframe: string = 'week') => {
  console.log(`Fetching real leaderboard data for timeframe: ${timeframe}...`)
  
  try {
    const response = await axios.get(`${API_BASE}/leaderboard?timeframe=${timeframe}`)
    // Return just the data portion, not the full response
    return response.data.data
  } catch (error) {
    console.error('Error fetching leaderboard:', error)
    throw error
  }
}

// Custom hook for leaderboard data
export const useLeaderboard = (timeframe: string = 'week') => {
  return useQuery({
    queryKey: ['leaderboard', timeframe],
    queryFn: () => fetchLeaderboard(timeframe),
    staleTime: 30 * 60 * 1000, // 30 minutes - free tier compliant refresh
    refetchInterval: 30 * 60 * 1000, // Refresh every 30 minutes to match collection frequency
    retry: 1,
    refetchOnWindowFocus: false,
  })
}

export default useLeaderboard 